import styled from "@emotion/styled";
import { Container } from "./layout";

export const StyledContainer = styled(Container)`
  flex: 1;
  display: flex;
`;

export const StyledPanel = styled.div`
  background-color: white;
  padding: 1rem;
  flex-grow: 1;
`;
